import React, { useEffect } from "react";
import "./App.css";
import HomeMain from "./Pages/Home/HomeMain";
import Navbar from "./Pages/Home/Navber";
import Footer from "./Pages/Home/Footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Services_main_page from "./Pages/Services/Services_main_page";
import Residential_projects from "./Pages/Services/Residential_projects.jsx";
import Commercial_spaces from "./Pages/Services/Commercial_spaces.jsx";
import PropertyConsultationForm from "./Pages/Services/Property_consultation.jsx";
import { useLocation } from "react-router-dom";
import PropertyDetails from "./Pages/PropertyDetails/DetailsMain.jsx";
import GalleryPage from "./ExtraComponent/GalleryPage.jsx";
import Login from "./Pages/Authentication/Login.jsx";
import Registration from "./Pages/Authentication/Registration.jsx";
import Profile from "./Pages/Authentication/Profile.jsx";

const ScrollToHash = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return null;
};




function App() {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="App">
     
      <BrowserRouter>
        <Navbar />
 <ScrollToHash/>
        <Routes>
          <Route path="/" element={<HomeMain />} />
          <Route path="/login" element={<Login/>} />
          <Route path="/register" element={<Registration/>} />
          <Route path="/profile" element={<Profile/>} />

          {/* SERVICES ROUTE */}
          <Route path="/services" element={<Services_main_page />}>
            
            {/* ✅ INDEX ROUTE (DEFAULT) */}


            {/* OPTIONAL: direct URL support */}
            <Route
            index
              // path="residential-projects"
              element={
                <Residential_projects />
              }
            />

            <Route
              path="commercial-spaces"
              element={
                <Commercial_spaces />
              }
            />

            <Route
              path="property-consultation"
              element={
                <PropertyConsultationForm />
              }
            />

          </Route>
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/property-details/:id" element={<PropertyDetails />} />
        </Routes>

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
